var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "protocol_search_item"
  }, [_vm._l(_vm.protocols, function (_ref, idx) {
    var material = _ref.material,
        equipment = _ref.equipment,
        measurement = _ref.measurement,
        analysis = _ref.analysis,
        protocolType = _ref.protocolType;
    return _c('div', {
      staticClass: "top_info"
    }, [_c('div', {
      staticClass: "txt_cont"
    }, [_c('div', {
      staticClass: "tit_label"
    }, [_c('span', {
      staticClass: "condition",
      class: _vm.publicActive != 0 ? 'open' : null
    }, [_vm._v(_vm._s(_vm.publicActiveList[_vm.publicActive]))]), _vm.uniqueNumber ? _c('span', {
      staticClass: "label_color color_02"
    }, [_vm._v(_vm._s(protocolType)), _c('em', [_vm._v("|")]), _vm._v(_vm._s(_vm.uniqueNumber))]) : _c('span', {
      staticClass: "label_color color_02"
    }, [_vm._v(_vm._s(protocolType))]), _c('span', {
      staticClass: "label_gray"
    }, [_vm._v(_vm._s(`${_vm.fieldName.split(">").join(" / ")}`))])]), _c('a', {
      staticClass: "tit_link",
      attrs: {
        "href": "javascript:void(0);"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.thisMyPage ? _vm.processName : _vm.name)
      },
      on: {
        "click": function ($event) {
          return _vm.goToDetail(_vm.protocolId, 'tree', 1);
        }
      }
    }), _c('ul', {
      staticClass: "protocol_label_list"
    }, [_vm._l(material ? material.split(';') : [], function (name) {
      return name.trim() !== '' ? _c('li', {
        staticClass: "label_01 material"
      }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
    }), _vm._l(measurement ? measurement.split(';') : [], function (name) {
      return name.trim() !== '' ? _c('li', {
        staticClass: "label_02 measurement"
      }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
    }), _vm._l(analysis ? analysis.split(';') : [], function (name) {
      return name.trim() !== '' ? _c('li', {
        staticClass: "label_04 analysis"
      }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
    }), _vm._l(equipment ? equipment.split(';') : [], function (name) {
      return name.trim() !== '' ? _c('li', {
        staticClass: "label_03 equipment"
      }, [_c('span', [_vm._v(_vm._s(name))])]) : _vm._e();
    })], 2)])]);
  }), _c('div', {
    staticClass: "bottom_info"
  }, [_c('ul', {
    staticClass: "user_set"
  }, [_c('li', [_vm._v(_vm._s(_vm.lastEditDate))]), _c('li', [_vm._v("책임작성자 : " + _vm._s(_vm.userName))]), _vm.collaborators.length ? _c('li', [_vm._v("공동작성자 : "), _vm._l(_vm.collaborators, function (collaborator, collaboratorKey) {
    var _collaborator$userNam, _collaborator$userNam2;

    return _c('span', {
      key: collaboratorKey
    }, [_vm._v(_vm._s(`${collaboratorKey != 0 ? " ," + ((_collaborator$userNam = collaborator.userName) !== null && _collaborator$userNam !== void 0 ? _collaborator$userNam : collaborator.name) : (_collaborator$userNam2 = collaborator.userName) !== null && _collaborator$userNam2 !== void 0 ? _collaborator$userNam2 : collaborator.name}`))]);
  })], 2) : _vm._e()]), _c('ul', {
    staticClass: "btn_set"
  }, [_c('li', [_c('a', {
    staticClass: "tree_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.goToDetail(_vm.protocolId, 'tree', 1);
      }
    }
  }, [_vm._v("트리보기")])]), _c('li', [_c('a', {
    staticClass: "wiki_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.goToDetail(_vm.protocolId, 'wiki', 1);
      }
    }
  }, [_vm._v("위키보기")])]), _vm.thisMyPage ? _c('li', [_vm.thisMyPage ? _c('a', {
    staticClass: "editor_move_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProtocolEditor');
      }
    }
  }, [_vm._v("에디터로 이동 ")]) : _vm._e()]) : _vm._e(), _vm.processType == 'NORMAL' ? _c('li', {
    staticClass: "process"
  }, [_c('a', {
    staticClass: "process_chart_btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('goToProcessDetail');
      }
    }
  }, [_vm._v("공정도 바로가기")])]) : _vm._e()])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }